import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconErrorCircleFill = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 16.73a.78.78 0 0 0 .575-.232.782.782 0 0 0 .233-.575.782.782 0 0 0-.232-.575.782.782 0 0 0-.576-.232.782.782 0 0 0-.575.232.782.782 0 0 0-.233.575c0 .229.078.42.232.575a.782.782 0 0 0 .576.233Zm0-3.653a.722.722 0 0 0 .534-.216.726.726 0 0 0 .216-.534v-4.5a.726.726 0 0 0-.216-.534.727.727 0 0 0-.534-.216.725.725 0 0 0-.534.216.726.726 0 0 0-.216.534v4.5c0 .213.072.39.216.534a.726.726 0 0 0 .534.216Zm.002 8.423a9.254 9.254 0 0 1-3.706-.748 9.596 9.596 0 0 1-3.016-2.03 9.595 9.595 0 0 1-2.032-3.016 9.246 9.246 0 0 1-.748-3.704c0-1.314.25-2.55.748-3.706a9.596 9.596 0 0 1 2.03-3.016 9.594 9.594 0 0 1 3.016-2.032 9.246 9.246 0 0 1 3.704-.748c1.314 0 2.55.25 3.706.748a9.596 9.596 0 0 1 3.017 2.03 9.594 9.594 0 0 1 2.03 3.016 9.247 9.247 0 0 1 .749 3.704 9.27 9.27 0 0 1-.748 3.706 9.596 9.596 0 0 1-2.03 3.017 9.595 9.595 0 0 1-3.016 2.03 9.247 9.247 0 0 1-3.704.749Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconErrorCircleFill;
